import { Database, ref, set } from 'firebase/database';

export const bannerOptionsUpdate = async (
	database: Database,
	bannerOptions: { visible: boolean; text: string }
): Promise<void> => {
	const normalizedValues = {
		visible: Boolean(bannerOptions.text.trim()) && bannerOptions.visible,
		text: bannerOptions.text.trim(),
	};

	return set(ref(database, 'settings/bannerOptions'), normalizedValues);
};
